import { render } from "./AssignShiftPermission.vue?vue&type=template&id=27ac8794"
import script from "./AssignShiftPermission.vue?vue&type=script&lang=js"
export * from "./AssignShiftPermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__